import React, { useEffect, useState } from "react";
import { Container, Table, Alert } from "react-bootstrap";
import { ApiGet } from "../../../service/ApiService";
import { useNavigate } from "react-router-dom";

const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Fetch invoices
  useEffect(() => {
    ApiGet(
      "/api/smartbill/invoice",
      (response) => {
        setInvoices(response);
        setError(null);
      },
      (err) => {
        setError("Eroare la preluarea facturilor.");
      }
    );
  }, []);

  // Fetch customers from the API.
  useEffect(() => {
    ApiGet(
      "/api/smartbill/customer/all",
      (response) => {
        setCustomers(response || []);
      },
      (err) => {
        console.error("Eroare la preluarea clienților.", err);
      }
    );
  }, []);

  // Helper function to get customer name by clientId.
  const getCustomerName = (clientId) => {
    const customer = customers.find((c) => c.id === clientId);
    return customer ? customer.clientName : clientId;
  };

  return (
    <Container className="mt-5">
      <h2>Facturi importate print BInt.ro</h2>
      <p className="text-muted mb-4">Nota: SmartBill nu permite descarcarea facturilor de pe platforma sa</p>
      {error && <Alert variant="danger">{error}</Alert>}
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Client</th>
            <th>Data Emiterii</th>
            <th>Data Scadenței</th>
            <th>Ciorna</th>
            <th>Monedă</th>
            <th>Limba</th>
            <th>Precizie</th>
            <th>Scade stoc</th>
            <th>Mențiuni</th>
            <th>Observații</th>
          </tr>
        </thead>
        <tbody>
          {invoices && invoices.length > 0 ? (
            invoices.map((inv) => (
              <tr
                key={inv.id}
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/smartbill/invoice/edit/${inv.id}`)}
              >
                <td>{inv.id}</td>
                <td>{getCustomerName(inv.clientId)}</td>
                <td>{inv.issueDate}</td>
                <td>{inv.dueDate}</td>
                <td>{inv.draft ? "Da" : "Nu"}</td>
                <td>{inv.currency}</td>
                <td>{inv.language}</td>
                <td>{inv.precision}</td>
                <td>{inv.useStock ? "Da" : "Nu"}</td>
                <td>{inv.mentions}</td>
                <td>{inv.observations}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center">
                Nu sunt facturi disponibile.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default InvoiceList;